import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Result, Alert, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import apiCalls from './api';
import { PowerBIEmbed } from 'powerbi-client-react';
import Loader from 'src/components/loader.component';
import NoData from '../shared/noDataComponent';
import HeaderComponent from '../header';

const Reports = () => {
    const shouldLog = useRef(true);
    let val = useParams();
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [reportdata, setReportdata] = useState(null);
    const [errorModalMsg, setErrorModalMsg] = useState(null);
    const [selectedReport, setSelectedReport] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [groupedReports, setGroupedReports] = useState({});

    useEffect(() => {
        if (shouldLog.current) {
            shouldLog.current = false;
        }
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        loadReports();
    }, []);

    const breadCrumbList = [
        { bname: 'Reports' },
    ];

    const loadReports = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        const response = await apiCalls.GetReports();
        if (response.ok) {
            if (response.data?.result) {
                const grouped = response.data.result.reduce((acc, report) => {
                    const groupName = report.groupName || 'Other';
                    acc[groupName] = acc[groupName] || [];
                    acc[groupName].push(report);
                    return acc;
                }, {});
                setGroupedReports(grouped);
                setIsLoading(false);
            } else {
                setErrorMessage(apiCalls.isErrorDispaly(response));
                setIsLoading(false);
            }
        } else {
            setErrorMessage(apiCalls.isErrorDispaly(response));
            setIsLoading(false);
        }
    }
    const showModal = useCallback((report) => () => {
        setIsLoading(true);
        apiCalls.getEmbidedReport(`EmbedReportAPI?reportName=${report?.name}`).then((res) => {
            if (res.ok) {
                setIsLoading(false);
                setReportdata(res.data);
            } else {
                setErrorModalMsg(true);
                setIsLoading(false);
            }
        });
        setSelectedReport(report);
        setIsModalVisible(true);
    }, []);

    const handleCancel = useCallback(() => {
        setIsModalVisible(false);
        setReportdata(null);
    }, [])

    const renderModalContent = useCallback(() => {
        if (isLoading) {
            return (
                <div className="text-center">
                    <Loader className="modal-loader" /> {/* Show loader inside modal */}
                </div>
            );
        }

        if (reportdata) {
            return (
                <div className="report_container">
                    <div className='powerbi-placeholder'></div>
                    <div className='licence-hider'></div>
                    <PowerBIEmbed
                        embedConfig={{
                            type: reportdata?.type,   // Supported types: report, dashboard, tile, visual, and qna
                            id: reportdata?.id,
                            embedUrl: reportdata?.embedUrl,
                            accessToken: reportdata?.accessToken?.token,
                            tokenType: 1,
                            settings: {
                                filterPaneEnabled: false,
                            }
                        }}
                        height={1000}
                        cssClassName={val?.reportname?.toLowerCase().includes('dashboard') ? "dashboard-styles" : "report-styles"}
                    />
                </div>
            );
        }

        if (errorModalMsg) {
            return (
                <Result
                    status="500"
                    title="Report Failed"
                    subTitle="Sorry, something went wrong."
                />
            );
        }
        return null;
    }, [reportdata, isLoading, errorModalMsg, val])
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    return (
        <div className=''>
            <HeaderComponent breadCrumbList={breadCrumbList} />
            {errorMessage !== undefined && errorMessage !== null && (
                <Alert
                    className='mb-6'
                    type="error"
                    description={errorMessage}
                    onClose={closeError}
                    showIcon
                    closable
                />

            )}
            <div className='text-center'>
                {isLoading && <Loader className="text-center" />}
            </div>
            <div>
                {Object.keys(groupedReports).map((groupName) => (
                    <div key={groupName} className='mt-9'>
                        <h3 className='text-2xl font-semibold text-titleColor mb-1.5 hidden md:block'>{groupName}</h3>
                        <div className="grid md:grid-cols-4 gap-4">
                            {groupedReports[groupName].map((report) => (
                                <div key={report?.id}>
                                    <div className='reports-cards mb-0' onClick={showModal(report)}>
                                        <div className='flex gap-2'>
                                            <span className='icon analytics'></span>
                                            <div className='report-data-ml'>
                                                <h4 className='report-name'>{report?.name}</h4>
                                                <p className='mb-0 report-description'>{report?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {groupedReports[groupName].length === 0 && <div className='md:col-span-3'>
                                <NoData text={`No data in ${groupName}`} />
                            </div>}
                        </div>
                    </div>
                ))}
                {Object.keys(groupedReports).length === 0 && !isLoading && (
                    <div className='mt-9'>
                        <NoData text={"No reports data available."} />
                    </div>
                )}
            </div>
            <Modal
                title={selectedReport?.title}
                open={isModalVisible}
                onCancel={handleCancel}
                className='modal-reports'
                wrapClassName='report-wrapper'
                style={{
                    top: 70,
                }}
                width={1800}
                closeIcon={
                    <Tooltip title={"close"}>
                        <span className='icon close'></span>
                    </Tooltip>}
                footer={[
                    <Button key="back" onClick={handleCancel} className='cancel-btn'>
                        Cancel
                    </Button>,
                ]}
            >
                {renderModalContent()}
            </Modal>
        </div>
    );
};

Reports.propTypes = {
    breadcrumb: PropTypes.array,
};

const mapStateToProps = ({ userConfig, oidc }) => ({
    userConfig: userConfig?.userProfileInfo,
    user: oidc?.user,
});

export default connect(mapStateToProps)(Reports);